import {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router-dom";
import Card from "../../Components/Cards/Card";
import axios from "axios";
import swal from 'sweetalert';
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";
import CustomerAddressComponent from "./CustomerAddressComponent";
import CustomerCardComponent from "./CustomerCardComponent";

const AdminProfile = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [customer, setCustomer] = useState([]);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [customerOrders, setCustomerOrders] = useState([]);
  const [customerCards, setCustomerCards] = useState([]);
  const [createdDate, setCreatedDate] = useState();
  const [isActive, setIsActive] = useState(null);
  const [newValue, setNewValue] = useState();

  useEffect(() => {
    axios.get('/customers/' + params.id)
      .then(response => {
        setCustomer(response?.data?.customer);
        setCustomerAddresses(response?.data?.addresses);
        setCustomerOrders(response?.data?.orders);
        setCustomerCards(response?.data?.cards);
        setIsActive(response?.data?.customer?.is_active);
        let createdAt = new Date(response?.data?.customer?.created_at).toLocaleDateString('en-GB');
        setCreatedDate(createdAt);
      })
  }, [newValue])

  const triggerLoop = (id) => {
    setNewValue(id);
  }

  const toggleActiveStatus = (id) => {
    axios.get('customer-is-active-toggle/' + id)
      .then((res) => {
        if (res.status == 200) {
          swal(`Customer has been ${isActive ? "blocked" : "unblocked"}!`, {
            icon: "success",
          });
          setIsActive(!isActive);
        }
      }).catch(function (error) {
    });
  }

  const renderOrdersTable = (ordersArray) => {
    return ordersArray.map((order, index) =>
      <>
        <tr key={index} className="col-xxl-4 col-xl-6 p-10 mb-lg-0 mb-10">
          <td
            className="color-primary cursor-pointer pl-3"
            title="Open"
            onClick={() => {
              navigate(`/orders/${order?.id}`)
            }}
          >
            {order?.id}
          </td>
          <td>
                        <span className={`badge ls-1 badge-light-${(() => {
                          let orderStatus;
                          switch (order?.status) {
                            case "Active":
                              orderStatus = "success";
                              break;
                            case "Pending":
                              orderStatus = "warning";
                              break;
                            case "Canceled":
                              orderStatus = "danger";
                              break;
                            case "Delivered":
                              orderStatus = "primary";
                              break;
                            default:
                              orderStatus = "secondary";
                          }
                          return orderStatus;
                        })()}`}>{order?.status}</span>
          </td>
          <td>
            {order?.price}
          </td>
          <td>
            {new Date(order?.order_date).toLocaleDateString('en-GB')}
          </td>
          <td className="orders-actions text-right">
            <i
              className="fas fa-search-plus mr-3 d-inline fs-3 cursor-pointer"
              title="Show Details"
              onClick={() => {
                navigate("/orders/" + order?.id)
              }}
            ></i>
            <i
              className="fas fa-edit mr-3 d-inline fs-3 cursor-pointer"
              title="Edit"
              onClick={() => {
                navigate("/orders/" + order?.id + "/edit")
              }}
            ></i>
          </td>
        </tr>
      </>
    )
  }

  return (
    <>
      <div className="row">
        <div className="col-xxl-5 px-xxl-3 mt-10">
          <Card title="Customer Profile" classes="customer-profile personal-info h-560-px">
            <div className="row">
              <div className="col-12 mb-5">
                <div
                  className="avatar"
                  style={{
                    background: `url(${customer?.avatar ? customer.avatar : avatarBlank})`
                  }}
                ></div>
                <div className="float-right">
                  <button
                    type="button"
                    className={`btn btn-${isActive ? "danger" : "success"} mt-3 float-right py-3 px-4`}
                    onClick={() => {
                      toggleActiveStatus(customer.id)
                    }}
                  >
                    <i className={`fas fa-${isActive ? "lock" : "lock-open"} mr-2 fs-7`}></i>
                    {isActive ? "Block" : "Unblock"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary mt-3 mr-3 float-right py-3 px-4"
                    onClick={
                      () => {
                        navigate("/customers/" + customer.id + "/edit")
                      }
                    }
                  >
                    <i className="fas fa-edit mr-2 fs-7"></i>
                    Edit
                  </button>
                </div>
              </div>
              <div className="col-md-6 ls-1 font-weight-normal">
                <ul className="li-style-none">
                  <li>
                    <h6 className="d-block mb-5">
                      <div className="fw-bolder mb-2 mt-3 color-dark-grey">Active:</div>
                      <span
                        className={`bg-${isActive ? "success" : "danger"} px-3 rounded py-1 text-white fw-bolder fs-6`}>
                                                {isActive ? "True" : "False"}
                                            </span>
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5 color-dark-grey">
                      <div className="fw-bolder mb-2 mt-3">First Name:</div>
                      {customer.first_name ? customer.first_name : "N/A"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5 color-dark-grey">
                      <div className="fw-bolder mb-2 mt-3">Last Name:</div>
                      {customer.last_name ? customer.last_name : "N/A"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5 color-dark-grey">
                      <div className="fw-bolder mb-2 mt-3">Birthday:</div>
                      {customer.birthday ? customer.birthday : "N/A"}
                    </h6>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 ls-1 font-weight-normal color-dark-grey">
                <ul className="li-style-none">
                  <li>
                    <h6 className="d-block mb-5">
                      <div className="fw-bolder mb-2 mt-3">Email:</div>
                      {customer.email ? customer.email : "N/A"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5">
                      <div className="fw-bolder mb-2 mt-3">Phone:</div>
                      {customer.phone ? customer.phone : "N/A"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5">
                      <div className="fw-bolder mb-2 mt-3">Created Date:</div>
                      {createdDate ? createdDate : "N/A"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5">
                      <div className="fw-bolder mb-2 mt-3">Personal Number:</div>
                      {customer.personal_number ? customer.personal_number : "N/A"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="d-block mb-5">
                      <div className="fw-bolder mb-2 mt-3">Identification Code:</div>
                      {customer.identification_code || "N/A"}
                    </h6>
                  </li>
                </ul>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-xxl-7 px-xxl-3 mt-10">
          <Card title="Addresses" classes="customer-profile addresses h-560-px" bodyClasses="px-lg-0">
            <div className="row">
              <div className="col-12 mb-5">
                <div className="address row">
                  <div className="col-12 mb-5 text-right">
                    <button
                      className="btn btn-light-primary"
                      onClick={() => {
                        navigate("/addresses/create/" + params.id);
                      }}
                    >
                      <i class="fas fa-plus fs-5 mr-2"></i>
                      Add New
                    </button>
                  </div>
                  {customerAddresses &&
                    (customerAddresses.map((address, index) =>
                      <CustomerAddressComponent
                        indexa={index}
                        key={index}
                        addressParam={address}
                        triggerLoop={triggerLoop}
                      />
                    ))
                  }
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-12 mt-10">
          <Card title="Bank Cards" classes="customer-profile bank_cards">
            <div className="row">
              <div className="col-12 mb-5">
                <div className="address row">
                  {customerCards &&
                    (customerCards.map((card, index) =>
                      <CustomerCardComponent
                        indexa={index}
                        key={index}
                        cardParam={card}
                        triggerLoop={triggerLoop}
                        classes="col-sm-4"
                      />
                    ))
                  }
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-12 mt-10">
          <Card title="Orders" classes="customer-profile orders">
            <div className="row">
              <div className="col-12 mb-5">
                <div className="order row">
                  <table className="table customer-orders align-middle table-row-dashed gy-5 no-footer color-dark-grey">
                    <thead>
                    <tr>
                      <th className="p-0 py-5 pl-3">Order ID</th>
                      <th className="p-0 py-5 pl-3">Status</th>
                      <th className="p-0 py-5 pl-3">Amount</th>
                      <th className="p-0 py-5 pl-3">Date</th>
                      <th className="p-0 py-5 pr-3 text-right">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {customerOrders && renderOrdersTable(customerOrders)}
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

export default AdminProfile;